// extracted by mini-css-extract-plugin
export default {"container":"submenu_container__3Nfl3","allDocuments":"submenu_allDocuments__Q7DQP","contentContainer":"submenu_contentContainer__4dcqe","active":"submenu_active__kwVv3"};